<template>

    <div
        class="mx-auto bg-gray-600 flex flex-nowrap whitespace-nowrap px-4 sm:px-6 lg:px-8 h-10 space-x-8"
    >
        <NavLink
            v-if="access('admin', 'currency_network')"
            :href="route('admin.currencies')"
            :active="route().current('admin.currencies')"
        >
            Валюты
        </NavLink>
        <NavLink
            v-if="access('admin', 'currency_network')"
            :href="route('admin.networks')"
            :active="route().current('admin.networks')"
        >
            Сети
        </NavLink>
        <NavLink
            v-if="access('admin', 'settings')"
            :href="route('admin.settings.index')"
            :active="route().current('admin.settings.index')"
        >
            Настройки
        </NavLink>
        <NavLink
            v-if="access('admin', 'telegram')"
            :href="route('admin.telegram')"
            :active="route().current('admin.telegram')"
        >
            Telegram
        </NavLink>

        <NavLink
            v-if="access('admin', 'logs')"
            href="/admin/logs"
            target="_blank"
        >
            Logs
        </NavLink>
    </div>
</template>

<script>
import NavLink from "@/Components/NavLink";

export default {
    components: {
        NavLink,
    },
}
</script>
